import script from "./PreviewKycForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewKycForm.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewKycForm.vue?vue&type=style&index=0&id=d92de1d2&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d92de1d2"]])

export default __exports__